import { ChevronLeft, ChevronRight, Mail } from "lucide-react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import KycStatusCell from "../../components/kyc-status-cell";
import { initialsOf } from "../../misc/utils";

const PublisherHeader = ({ publisher, publisherName, email, brands, crumbs }) => {
    const back = crumbs[crumbs.length - 1];
    return (
        <div>
            <nav className="flex min-w-0 items-center gap-1 text-sm text-muted">
                <Link to={back.to} state={back.state} title="Back" className="mr-1 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md hover:bg-gray-50 hover:text-gray-700">
                    <ChevronLeft className="h-4 w-4" />
                </Link>
                {crumbs.map((crumb) => (
                    <span key={crumb.to} className="flex min-w-0 items-center gap-1">
                        <Link to={crumb.to} state={crumb.state} className="truncate hover:text-gray-700 hover:underline">{crumb.label}</Link>
                        <ChevronRight className="h-3.5 w-3.5 shrink-0" />
                    </span>
                ))}
                <span className="truncate font-medium text-gray-900">{publisherName}</span>
            </nav>

            <div className="mt-3 flex items-center gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-light text-base font-semibold text-primary">
                    {initialsOf(publisherName)}
                </span>
                <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-3">
                        <h1 className="truncate text-2xl font-semibold tracking-tight">{publisherName}</h1>
                        {publisher?.kyc_status && <KycStatusCell publisher={publisher} />}
                    </div>
                    <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted">
                        {email && (
                            <span className="inline-flex items-center gap-1.5">
                                <Mail className="h-3.5 w-3.5" />
                                {email}
                            </span>
                        )}
                        {brands.map((brand) => (
                            <span key={brand} className="rounded-md bg-light px-2 py-0.5 text-xs font-medium text-primary">{brand}</span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

PublisherHeader.propTypes = {
    publisher    : PropTypes.object,
    publisherName: PropTypes.string.isRequired,
    email        : PropTypes.string,
    brands       : PropTypes.arrayOf(PropTypes.string).isRequired,
    crumbs       : PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, to: PropTypes.string, state: PropTypes.object })).isRequired
};

export default PublisherHeader;
